import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as EmptyInboxIcon } from '../../assets/icons/empty-inbox.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';

interface TwDriverAckConfirmationModalContentProps {
  handleConfirm: () => void;
  isLoading: boolean;
  isLoadingTrip: boolean;
}

export const TwDriverAckConfirmationModalContent = ({
  handleConfirm,
  isLoading,
  isLoadingTrip
}: TwDriverAckConfirmationModalContentProps): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
      <EmptyInboxIcon />
      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px' }}>
        Dispatch confirmation required
      </Typography>
      <Typography variant="body2" sx={{ textAlign: 'center', color: '#6B7280' }}>
        You have been assigned a new trip. Please confirm that you have received it and review the
        dispatch details.
      </Typography>

      <TwButton
        label="Confirm receipt"
        action={handleConfirm}
        type={TwButtonType.primary}
        disabled={isLoading || isLoadingTrip}
        fullwidth={false}
      />
    </Box>
  );
};
